import { axiosService } from "./axiosService";

const imageApi = {
    uploadImage(body) {
        const url = '/image';
        return axiosService.post(url, body)
    },
    deleteImage(id, params = {}) {
        const url = `/image/${id}`;
        return axiosService.delete(url, { params })
    },
}

export default imageApi;